"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _root_model = _interopRequireDefault(require("./root_model"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var XpBreakdown = (_dec = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _class = /*#__PURE__*/function (_RootModel) {
  function XpBreakdown() {
    var _this;
    _classCallCheck(this, XpBreakdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, XpBreakdown, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "xpSlug", _descriptor2, _this);
    _initializerDefineProperty(_this, "xp", _descriptor3, _this);
    _initializerDefineProperty(_this, "count", _descriptor4, _this);
    _initializerDefineProperty(_this, "occurredAtTimeUtc0", _descriptor5, _this);
    _initializerDefineProperty(_this, "occurredAtTimeLocal", _descriptor6, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor7, _this);
    _initializerDefineProperty(_this, "deckId", _descriptor8, _this);
    _initializerDefineProperty(_this, "dailyGoal", _descriptor9, _this);
    _initializerDefineProperty(_this, "occurredAtDatetimeUtc0", _descriptor0, _this);
    _initializerDefineProperty(_this, "occurredAtDatetimeLocal", _descriptor1, _this);
    return _this;
  }
  _inherits(XpBreakdown, _RootModel);
  return _createClass(XpBreakdown, [{
    key: "xpDescriptionFromSlug",
    get: function get() {
      var xpDescription;
      switch (this.xpSlug) {
        case 'exercise':
          xpDescription = 'Exercise Card';
          break;
        case 'trivia':
          xpDescription = 'Trivia Card';
          break;
        case 'gender':
          xpDescription = 'Gender Card';
          break;
        case 'plural':
          xpDescription = 'Plural Card';
          break;
        case 'case':
          xpDescription = 'Case Card';
          break;
        case 'card':
          xpDescription = 'Card Seen';
          break;
        case 'card-add-to-review':
          xpDescription = 'Add to Reviews';
          break;
        case 'card-review-deck':
          xpDescription = 'Review Card';
          break;
        case 'feed-entry-text':
          xpDescription = 'Submit Feed Entry';
          break;
        case 'feed-entry-audio':
          xpDescription = 'Submit Feed Entry';
          break;
        case 'feed-entry-video':
          xpDescription = 'Submit Feed Entry';
          break;
        case 'comment':
        case 'comment-response':
          xpDescription = 'Comment Posted';
          break;
        case 'correction':
        case 'comment-correction':
          xpDescription = 'Correction';
          break;
        case 'comment-transcription':
          xpDescription = 'Transcription';
          break;
        case 'user-exercise-correct':
          xpDescription = 'Exercise Completed with Perfect Score';
          break;
        case 'transcription':
          xpDescription = 'Transcription';
          break;
        case 'feed-entry-like':
          xpDescription = 'Liked a Feed Entry';
          break;
        case 'correction-thanks':
          xpDescription = 'Thanked for a Correction';
          break;
        default:
          xpDescription = (0, _lodash.capitalize)(this.xpSlug);
      }
      return xpDescription;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "xpSlug", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "xp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "count", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "occurredAtTimeUtc0", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "occurredAtTimeLocal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "deckId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "dailyGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "occurredAtDatetimeUtc0", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "occurredAtDatetimeLocal", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "xpDescriptionFromSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "xpDescriptionFromSlug"), _class.prototype), _class);
var _default = exports["default"] = XpBreakdown;